import React from "react";
import ReactApexChart from "react-apexcharts";

class SocialNetworkRadialChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.getChartState(props);
  }

  getCssVar = (name, fallback) => {
    try {
      const v = getComputedStyle(
        document.documentElement
      ).getPropertyValue(name);

      return (v || "").trim() || fallback;
    } catch {
      return fallback;
    }
  };

  buildOptions = (displayTotal) => {
    const secondary = this.getCssVar(
      "--secondary",
      "#3AC977"
    );

    return {
      chart: {
        type: "radialBar",
        offsetY: 0,
        height: 200,
        sparkline: {
          enabled: true,
        },
      },

      colors: [secondary],

      plotOptions: {
        radialBar: {
          startAngle: -180,
          endAngle: 180,

          track: {
            background: this.getCssVar(
              "--rgba-secondary-1",
              "#eef2f7"
            ),
            strokeWidth: "100%",
            margin: 3,
          },

          hollow: {
            margin: 20,
            size: "60%",
            background: "transparent",
          },

          dataLabels: {
            name: {
              show: false,
            },

            value: {
              offsetY: 5,
              fontSize: "16px",
              color: "#000000",
              fontWeight: 600,

              formatter: () =>
                `₹${new Intl.NumberFormat("en-IN", {
                  maximumFractionDigits: 0,
                }).format(Number(displayTotal || 0))}`,
            },
          },
        },
      },

      fill: {
        type: "gradient",

        gradient: {
          shade: "dark",
          shadeIntensity: 0.15,
          inverseColors: false,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 50, 100],
        },
      },

      labels: ["Collection"],

      responsive: [
        {
          breakpoint: 1600,
          options: {
            chart: {
              height: 150,
            },
          },
        },
      ],
    };
  };

  getChartState = (props) => {
    const value = Number(props.value || 0);

    return {
      series: [100],
      options: this.buildOptions(value),
    };
  };

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState(
        this.getChartState(this.props)
      );
    }
  }

  render() {
    return (
      <div id="redial">
        <ReactApexChart
          options={this.state.options}
          series={this.state.series}
          type="radialBar"
          height={200}
        />
      </div>
    );
  }
}

export default SocialNetworkRadialChart;